import React from 'react';

export const WheelPicker = ({ children, ...props }) => <div >{children}</div>;
export default ({ children, ...props }) => <div>{children}</div>;
